module.exports = __webpack_public_path__ + "img/tank1.a6236dfc.png";